import useDialogs from './useDialogs';

export default useDialogs;
